import styled from 'styled-components'
import { Typography } from '@chegg-ui/typography'
import { font, spacing, colors } from '@chegg-ui/theme'

export const EmptySuggestionsCardHeading = styled(Typography).attrs({
  variant: 'h1',
  variantType: 'bold',
})`
  font-size: ${font.size.px22};
  line-height: ${font.lineHeight.md};
  margin-top: ${spacing.px32};
  text-align: center;

  span {
    color: ${colors.orange900};
  }
`

export const EmptySuggestionsCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${spacing.px96} ${spacing.px32};
  max-width: 372px;
`

export const EmptySuggestionCopy = styled.p`
  line-height: ${font.lineHeight.md};
  letter-spacing: initial;
  font-weight: ${font.weight.medium};
  font-size: ${font.size.px14};
  color: ${colors.grey900};
  margin-top: ${spacing.px12};
  text-align: center;
`
